import { render, staticRenderFns } from "./ImageGridSection.vue?vue&type=template&id=6c4ba87a&"
import script from "./ImageGridSection.vue?vue&type=script&lang=js&"
export * from "./ImageGridSection.vue?vue&type=script&lang=js&"
import style0 from "./ImageGridSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports